var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20001 4.575L6.30001 1.675C6.11667 1.49167 6.02501 1.25833 6.02501 0.975C6.02501 0.691666 6.11667 0.458333 6.30001 0.275C6.48334 0.0916664 6.71667 -2.57169e-07 7.00001 -2.44784e-07C7.28334 -2.32399e-07 7.51667 0.0916664 7.70001 0.275L12.3 4.875C12.5 5.075 12.6 5.30833 12.6 5.575C12.6 5.84167 12.5 6.075 12.3 6.275L7.70001 10.875C7.51667 11.0583 7.28334 11.15 7.00001 11.15C6.71667 11.15 6.48334 11.0583 6.30001 10.875C6.11667 10.6917 6.02501 10.4583 6.02501 10.175C6.02501 9.89167 6.11667 9.65833 6.30001 9.475L9.20001 6.575L1.00001 6.575C0.716672 6.575 0.479172 6.47917 0.287506 6.2875C0.0958392 6.09583 5.46597e-06 5.85833 5.47835e-06 5.575C5.49074e-06 5.29167 0.0958393 5.05417 0.287506 4.8625C0.479173 4.67083 0.716672 4.575 1.00001 4.575L9.20001 4.575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightArrow);
export default __webpack_public_path__ + "static/media/ic_right_arrow.9355a7432e2d88fbc2e70a62240469b5.svg";
export { ForwardRef as ReactComponent };